import Vue from "vue/dist/vue.common";

export default {
    state: {
        delivery: [],
        props: []
    },
    actions: {
    },
    mutations: {
        setDelivery(state, delivery) {
            state.delivery = delivery;
        },
        setProps(state, props) {
            state.props = props;
        },
        setActiveDelivery(state, id) {
            state.delivery = state.delivery.map(delivery => {
                Vue.set(delivery, "CHECKED", (delivery.ID === id) ? "Y" : "N");
                return delivery;
            });
        },
        setActiveDate(state, id) {
            const prop = state.props.find(prop => prop.code === "DELIVERY_TIME");
            if (prop && prop.value) {
                prop.value = prop.value.map(field => {
                    Vue.set(field, "checked", (field.id === id) ? true : false);
                    return field;
                });
            }
        },
        setActiveTime(state, id) {
            const prop = state.props.find(prop => prop.code === "DELIVERY_TIME");
            if (prop && prop.value) {
                let selected = prop.value.find(date => date.checked);
                selected.time = selected.time.map(time => {
                    Vue.set(time, "checked", (time.id === id) ? true : false);
                    return time;
                });
            }
        },
        setActivePickupPoint(state, id) {
            const prop = state.props.find(prop => prop.code === "PICKUP_POINT");
			prop.value.forEach(point => Vue.set(point, "checked", (point.id === id) ? true : false));
        },
        setRadioPropValue(state, {value, code}) {
            const prop = state.props.find(prop => prop.code === code);
            if (prop) {
                Vue.set(prop, "selectedValue", value);
            }
        },
        setPropValue(state, {value, code}) {
            const prop = state.props.find(prop => prop.code === code);
			if (prop) {
				prop.value = value;
			}
        },
        unselectUserAddresses(state) {
            const prop = state.props.find(prop => prop.code === "ADDRESSES");
            if (prop && prop.value) {
                prop.value = prop.value.map(address => {
                    address.checked = false;
                    return address;
                });
            }
        },
        setActiveUserAddress(state, id) {
            const prop = state.props.find(prop => prop.code === "ADDRESSES");
            if (prop && prop.value) {
                prop.value = prop.value.map(address => {
                    Vue.set(address, "checked", (address.id === id) ? true : false);
                    return address;
                });
            }
        },
    },
    getters: {
        deliveries(state, getters) {
            return state.delivery;
        },
        activeDelivery(state, getters) {
            return getters.deliveries.find((delivery) => delivery.CHECKED === "Y");
        },
		pickupPoints(state) {
			const prop = state.props.find(prop => prop.code === "PICKUP_POINT");
			return prop.value;
		},
        userAddresses(state) {
            const prop = state.props.find(prop => prop.code === "ADDRESSES");
            return (prop) ? prop.value : [];
        },
        activeUserAddress(state, getters) {
            return getters.userAddresses.find((address) => address.checked);
        },
		city(state) {
			const prop = state.props.find(prop => prop.code === "CITY");
			return prop.value;
		},
		cityTo(state) {
			const prop = state.props.find(prop => prop.code === "CITY_TO");
			return prop.value;
		},
    },
    namespaced: true
}
